// Library Methods
import { useQuery } from "@tanstack/react-query";

// Hooks
import useTokenAccess from "src/hooks/auth/useTokenAccess";

// Types and API
import { getClinicProgressionAnalysisStatistics } from "../../api";
import { ClinicProgressionAnalysisStatsType } from "../../types";

export const useClinicProgressionAnalysisStats = (
  clinicId: string | undefined,
  payload: { recentFilterDate: string },
  enabled: boolean = true
) => {
  const { getToken } = useTokenAccess();

  return useQuery<ClinicProgressionAnalysisStatsType>({
    queryKey: ["clinic-progression-analysis-stats", clinicId, payload],
    queryFn: async () => {
      if (!clinicId) throw new Error();
      const token = await getToken();
      const controller = new AbortController();
      return getClinicProgressionAnalysisStatistics(
        token,
        clinicId,
        payload,
        controller.signal
      );
    },
    enabled,
    refetchOnWindowFocus: false,
    staleTime: 5 * 60 * 1000, // optional: cache for 5 minutes
  });
};
